// utils/notificationFormatter.ts
import { TFunction } from "i18next";

import { ToDoPriority } from "@/pages/Private/pages/TasksAndSubTasks/enum/ToDoPriority.enum";
import { ToDoStatus } from "@/pages/Private/pages/TasksAndSubTasks/enum/ToDoStatus.enum";

export const formatNotificationMessage = (
	message: string | null,
	metadata: Record<string, unknown> | null,
	t: TFunction
): string => {
	if (!message) {
		return "";
	}

	let formatted = message;

	// If metadata contains status or priority, append formatted values
	if (metadata?.newStatus) {
		const status = metadata.newStatus as ToDoStatus;
		const statusLabels: Record<ToDoStatus, string> = {
			[ToDoStatus.TO_DO]: t("to-do.TO_DO"),
			[ToDoStatus.IN_PROGRESS]: t("to-do.IN_PROGRESS"),
			[ToDoStatus.DONE]: t("to-do.DONE"),
			[ToDoStatus.QA]: t("to-do.QA"),
		};

		formatted += ` → ${statusLabels[status] || status}`;
	}

	if (metadata?.newPriority) {
		const priority = metadata.newPriority as ToDoPriority;
		const priorityLabels: Record<ToDoPriority, string> = {
			[ToDoPriority.LOW]: t("priority.low") || "Low",
			[ToDoPriority.MEDIUM]: t("priority.medium") || "Medium",
			[ToDoPriority.HIGH]: t("priority.high") || "High",
		};

		formatted += ` → ${priorityLabels[priority] || priority}`;
	}

	return formatted;
};
